<template>
    <div v-if="view">
      <div class="date-cont date-cont-home" v-if="type=='black'||type=='black3'">
        <span class="text black">{{int_day}}</span>
        <span class="fu" style="color: #333;">&nbsp;:&nbsp;</span>
        <span class="text black">{{int_hour}}</span>
        <span class="fu" style="color: #333;">&nbsp;:&nbsp;</span>
        <span class="text black">{{int_minute}}</span>
        <span class="fu" style="color: #333;">&nbsp;:&nbsp;</span>
        <span class="text" :style="type=='black'?'background:linear-gradient(135deg,rgba(255,142,0,1) 0%,rgba(221,43,30,1) 100%);color:#fff;':'background:#FF6600;color:#fff;'">{{int_second}}</span>
      </div>
      <div class="date-cont date-cont-home small" v-if="type==='black2'">
        <span class="text black">{{int_day}}</span>
        <span class="fu" style="color: #333;">&nbsp;:&nbsp;</span>
        <span class="text black">{{int_hour}}</span>
        <span class="fu" style="color: #333;">&nbsp;:&nbsp;</span>
        <span class="text black">{{int_minute}}</span>
        <span class="fu" style="color: #333;">&nbsp;:&nbsp;</span>
        <span class="text" style="background:#FF6600;color:#fff;">{{int_second}}</span>
      </div>
    </div>
</template>

<script>
export default {
  name: 'date',
  props: {
    date: String,
    type: String,
    index: Number
  },
  data () {
    return {
      int_day: '00',
      int_hour: '00',
      int_minute: '00',
      int_second: '00',
      msg: 9,
      view: false,
      timer: null,
    }
  },
  created () {
    this.countDown(this.date);
  },
  methods: {
    countDown (times) {
      var timer = null;
      timer = setInterval(() => {
        if (times <= 0) {
          this.$emit('dateFn',times)
          clearInterval(timer);
        }
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0,
          hm = 0; // 时间默认值
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24));
          hour = Math.floor(times / (60 * 60)) - (day * 24);
          minute = Math.floor(times / 60) - (day * 24 * 60) - (hour * 60);
          second = Math.floor(times) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
        }
        if (day <= 9) day = '0' + day;
        if (hour <= 9) hour = '0' + hour;
        if (minute <= 9) minute = '0' + minute;
        if (second <= 9) second = '0' + second;
          this.int_day = day
          this.int_hour = hour;
          this.int_minute = minute;
          this.int_second = second;
        this.view = true;
        times--;
      }, 1000);
    },
  }
}
</script>

<style scoped>
  .date-cont span{
    display: inline-block;
    color: #fff;
  }
  .date-cont .text{
    font-size: 0.22rem;
    width: 0.4rem;
    height: 0.4rem;
    background: #fff;
    color: #FF5202;
    text-align: center;
    line-height: 0.4rem;
    border-radius: 0.06rem;
  }
  .small .text{
    font-size: 0.2rem;
    width: 0.32rem;
    height: 0.32rem;
    border-radius: 0.04rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .date-cont .fu{
    height: 0.4rem;
    line-height: 0.4rem;
  }

  .date-cont .white{
    color: #FF5202;
    background: #fff;
  }
  .date-cont-home .black{
    color: #fff;
    background: #606060;
  }
  .date-cont-home .red{
    color: #fff;
    background:linear-gradient(90deg,rgba(255,147,73,1) 0%,rgba(250,79,72,1) 100%);
  }
  .date-cont-home .yellow{
    background:#FFD003;
    color: #fff;
  }
</style>
